import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

export const saveResourceStats = async (eventId: number, email: string, attachmentId: string, name:string, url:string) => {
  try {
    const response = await axios.post(
      `${HOSTAPI}/events/${eventId}/resource-stats`, 
      {
        email,
        attachmentId,  
        name,
        url
      }
    );

    if (response.data.status === 'success') {
      return response.data; 
    }
  } catch (error) {
    console.error("Error saving resource stats:", error);
  }
}; 